import * as React from 'react';
import { parseProductData, getIncludedVatAmount, getPriceSpecificationConfig, Product } from '@grandvisionhq/analytics';
import { isDefined } from '@grandvisionhq/utils';
import { useProductDetailContext } from '../ProductDetail/Context/ProductDetailContext.js';

const ProductStructuredDataObject = ({ product , locale , extra  })=>{
    const { activeSku , productUrl  } = useProductDetailContext();
    const activeVariant = [
        product.masterVariant,
        ...product.variants
    ].find((variant)=>variant.sku === activeSku
    ) || product.masterVariant;
    const { name , image , description , brand , category , sku  } = parseProductData(product, activeVariant, locale);
    const vat = getIncludedVatAmount(product);
    var _prices;
    const pricing = ((_prices = activeVariant.prices) !== null && _prices !== void 0 ? _prices : []).find((price)=>typeof price.value.centAmount !== 'undefined'
    );
    const priceSpecification = isDefined(pricing) ? getPriceSpecificationConfig(pricing, vat) : undefined;
    return /*#__PURE__*/ React.createElement(Product, {
        brand: String(brand),
        category: category,
        description: description,
        extra: extra,
        image: image,
        name: String(name),
        priceSpecificationConfig: priceSpecification,
        ratingsSummary: product.ratingsSummary,
        sku: sku,
        url: productUrl
    });
};

export { ProductStructuredDataObject };
//# sourceMappingURL=ProductStructuredDataObject.js.map
